export class TestedPartyErrorResponse {
  name: any;
  'primaryFunction.primaryFunctionId': any;
  segmentType: any;
  justification: any;
}
